export default __webpack_public_path__ + "static/media/airlockz-cbb-banner-3.b0ea7800.jpg";